<template>
  <v-app>
    <div v-if="pageIsLoading" class="loading">
      <i class="fa fa-spinner fa-spin fa-2x mx-3"></i>
      <span>Loading ... </span>
    </div>
    <navigation 
      v-if="token !== '' 
            && $router.currentRoute.name !== 'login'
            && (!smAndDown || !$store.state.toggle.drawer)"
    />
    <router-view 
      :class="{
        'smAndDown': smAndDown
      }"
    />
    <message-modal />
    <spinner />
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import MessageModal from '@/components/MessageModal.vue';
import Navigation from '@/components/Navigation.vue';
import Spinner from '@/components/Spinner.vue';
import { 
  SET_ACTIVE_ELEMENT
} from '@/store/mutation-types';
export default {
  name: 'App',
  components: {
    MessageModal,
    Navigation,
    Spinner
  },
  computed: {
    ...mapState({
      message: state => state.toggle.messageModal,
      token: state => state.auth.token,
      pageIsLoading: state => state.toggle.pageIsLoading,
    }),
  },
  watch: {
    token(newToken) {
      if(newToken) {
        const visibleMenu = this.$store.getters.getVisibleMenu(this.can);
        if(visibleMenu.length == 0) return;
        let firstLink = visibleMenu[0];
        if(firstLink.route) {
          this.$router.replace({ name: firstLink.route });
        } else if(firstLink.children) {
          this.$router.replace({ name: firstLink.children[0].route });
        }
      } else {
        this.$router.replace({ name: 'login' });
      }
      const routeName = newToken ? 'dashboard' : 'login';
      
    },
  },
  async mounted() {
    document.addEventListener('click', this.onClick);
    if(this.smAndDown) {
      document.body.classList.add('smAndDown');
    }
  },
  methods: {
    onClick(evt) {
      this.$store.commit(SET_ACTIVE_ELEMENT, evt.target);
    }
  }
};
</script>
